export default __webpack_public_path__ + "static/indoor26-4d54f54d6337ebd5ec0e0c76114fb994.webp";